module.exports = __webpack_public_path__ + "img/3b61f40c-04fe-4dee-aa8c-633a8d7c0d20.e0461a26035acce8cb7c71752bdf0496.a97bec34.webp";